/**
 * A stock item that failed IQ submission because one or more barcodes already exist.
 */
export interface INotificationDuplicateBarcodeError {
  failedBarcodes: string[];
  stockCode: string;
  errorDescription?: string;
}
